import { render } from "./outer-section-v2.vue?vue&type=template&id=3245672e&scoped=true"
import script from "./outer-section-v2.vue?vue&type=script&lang=js"
export * from "./outer-section-v2.vue?vue&type=script&lang=js"

import "./outer-section-v2.vue?vue&type=style&index=0&id=3245672e&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3245672e"]])

export default __exports__